/* eslint-disable max-len */
const landings = require('./json/landingsPartners.json');
const localitiesLandings = require('./json/landingsLocalities.json');
const localitiesLeatherGoodsLandings = require('./json/landingsLocalitiesLeatherGoods.json');
const localitiesShoesLandings = require('./json/landingsLocalitiesShoes.json');
const localitiesRepairLandings = require('./json/landingsLocalitiesRepair.json');
const landingsAds = require('./json/landingsAds.json');
const landingsAdsV4 = require('./json/landingsAdsV4.json');
const landingsAdsPieces = require('./json/landingsAdsPieces.json');
const landingsAdsCurtains = require('./json/landingsAdsCurtains.json');
const {
  getSeo, getPath, getRepairPath, getLeatherGoodsPath, getLeatherGoodsPathV2, getLeatherGoodsSeo, getShoesPath, getShoesSeo, getRepairSeo,
  getShoesPathV2,
} = require('./services/seoLocalitiesFormatter');
const routesHome = require('./config/routes/routes.home');
const routesMyAccount = require('./config/routes/routes.myAccount');
const routesOrder = require('./config/routes/routes.order');

Object.keys(routesOrder).forEach((route) => {
  routesOrder[route].isRouteNotIndexedBySearchEngine = true;
});

const routes = {
  ...routesHome,
  ...routesMyAccount,
  ...routesOrder,
};

landings.filter((landing) => !landing.disabled).forEach((landing) => {
  routes[landing.slug] = {
    url: landing.path,
    seo: landing.seo,
  };
});

localitiesLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getPath(landing),
    seo: getSeo(landing),
  };
});

localitiesRepairLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getRepairPath(landing),
    seo: getRepairSeo(landing),
  };
});

localitiesLeatherGoodsLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getLeatherGoodsPath(landing),
    seo: getLeatherGoodsSeo(landing),
  };
});

localitiesLeatherGoodsLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getLeatherGoodsPathV2(landing),
    seo: getLeatherGoodsSeo(landing),
  };
});

localitiesShoesLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getShoesPath(landing),
    seo: getShoesSeo(landing),
  };
});

localitiesShoesLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getShoesPathV2(landing),
    seo: getShoesSeo(landing),
  };
});

landingsAds.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});
landingsAdsV4.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});
landingsAdsPieces.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});
landingsAdsCurtains.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});

module.exports = routes;
